import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useSelected } from '../company/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useOpenDriveExport = () => {
  const { selectedCompanyId: companyId } = useSelected();
  const { mutate: mutateOpenDriveExport, isPending } = useAppMutation(
    [QueryKey.OPEN_DRIVE_EXPORT, companyId],
    {
      mutationFn: async () => {
        await ApiService.downloadFile({
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'vault', 'open-drive', 'export'],
        });
      },
    },
  );

  return { mutateOpenDriveExport, isPending };
};
